import { render } from "./ReadonlyWidget.vue?vue&type=template&id=65a247d6"
import script from "./ReadonlyWidget.vue?vue&type=script&lang=js"
export * from "./ReadonlyWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__